import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Divider } from 'antd';
import TopBar from './TopBar';
import Comments from './Comments';
import Navbar from './NavBar';
import Title from './Title';
import { getUserProfile } from '@store/common/selectors';
import { StyledWrapper } from './styled';
import useFetchAnnotation from '../hooks/useFetchAnnotation';
import { getTitle, buildAnnotationObj } from '../hooks/utils';
import { get } from 'lodash';

export interface IAnnotation {
  annotationId?: number,
  filterName: string,
  metricKey: string,
  startTimestamp: string,
  endTimestamp: string,
  filterRule: object,
  annotationType: string,
  isPublic: boolean,
  productId: number,
  comments: Array<any>,
  createdBy?: number,
}



const Content = ({ setOpen, annotationId = null, ...details }) => {
  const { metricKey } = details;

  const profile = useSelector(getUserProfile);
  const { data: annotationObj } = useFetchAnnotation({ id: annotationId });

  const [activeAnnotation, setActiveAnnotation] = useState<IAnnotation|null>(null);

  useEffect(() => {
    const selectedAnnotation = annotationId ?
      get(annotationObj, 'annotation', null)
      : buildAnnotationObj({...details, createdBy: profile.profile_id});
    setActiveAnnotation(selectedAnnotation);
  }, [annotationId, annotationObj]);

  const title = useMemo(() => {
    return activeAnnotation ? getTitle(activeAnnotation) : '';
  }, [activeAnnotation]);

  const updateActiveAnnotation = (data: any) => {
    setActiveAnnotation({ ...activeAnnotation, ...data });
  }

  return activeAnnotation ? (<StyledWrapper>
    <TopBar setOpen={setOpen} />
    <Navbar
      activeAnnotation={activeAnnotation}
      profile={profile}
      updateActiveAnnotation={updateActiveAnnotation}
      metricKey={metricKey}
      setOpen={setOpen}
    />
    <Divider />
    <Title title={title} />
    <Comments
      activeAnnotation={activeAnnotation}
      profile={profile}
      setOpen={setOpen}
    />
  </StyledWrapper>) : '...loading';
}

export default Content;
